export const extractThumbnail = (videoFile) =>
  new Promise((resolve, reject) => {
    const videoElement = document.createElement('video');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const fileURL = URL.createObjectURL(videoFile);
    videoElement.src = fileURL;

    videoElement.addEventListener('loadeddata', () => {
      // Set canvas dimensions to video dimensions
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;

      // Seek to the beginning of the video
      videoElement.currentTime = 0;
    });

    // Event listener for when the video seeks to the desired time
    const onSeeked = async () => {
      // Draw the first frame of the video on the canvas
      context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      // Convert canvas to Blob
      canvas.toBlob((blob) => {
        // Clean up object URL
        URL.revokeObjectURL(fileURL);

        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to create thumbnail: Blob is null'));
        }
      }, 'image/jpeg');
    };

    videoElement.addEventListener('seeked', onSeeked);

    videoElement.addEventListener('error', (err) => {
      URL.revokeObjectURL(fileURL); // Clean up object URL
      reject(new Error(`Error loading video: ${err.message}`));
    });

    // Load the video
    videoElement.load();
  });
